"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.discountedCarRentalCompaniesCVR = exports.getOwnerIsCompanyFromDMR = exports.getOwnerAddressFromDMR = exports.getOwnerFromDMR = exports.getUserIsCompanyFromDMR = exports.getUserAddressFromDMR = exports.getUserFromDMR = exports.APCOA_AUTOMATSAG = exports.APCOA_EI_TENANT_IDS = exports.EUROINCASSO_TENANT_IDS = exports.APCOA_TENANT_IDS = void 0;
const moment_1 = __importDefault(require("moment"));
const __1 = require("..");
exports.APCOA_TENANT_IDS = [
    __1.bespokeTenants.apcoaProd,
    __1.bespokeTenants.apcoaSandbox,
];
exports.EUROINCASSO_TENANT_IDS = [
    __1.bespokeTenants.euroIncassoProd,
    __1.bespokeTenants.euroIncassoSandbox,
];
exports.APCOA_EI_TENANT_IDS = [
    ...exports.APCOA_TENANT_IDS,
    ...exports.EUROINCASSO_TENANT_IDS,
];
exports.APCOA_AUTOMATSAG = process.env.NODE_ENV === 'production'
    ? 'ce15e0a1-ea8e-46c1-ab42-9e46004edf42'
    : '9a5122eb-7654-4d89-9fa5-070d4867e3dc';
const getUserFromDMR = (dmr) => {
    return {
        address: (0, exports.getUserAddressFromDMR)(dmr),
        isCompany: (0, exports.getUserIsCompanyFromDMR)(dmr),
        birthdate: (0, moment_1.default)(dmr.User_Birth_Date, 'YYYY-MM-DD').toISOString(),
        description: 'Bruger fra DMR',
        name: dmr.User_Name,
        cvr: dmr.User_VAT_Registration_No || null,
    };
};
exports.getUserFromDMR = getUserFromDMR;
const getUserAddressFromDMR = (dmr) => {
    return {
        address: dmr.User_Address,
        coAddress: dmr.User_Address_2,
        zipcode: dmr.User_Post_Code,
        city: dmr.User_City,
        country: dmr.User_Country_Code || 'Danmark',
    };
};
exports.getUserAddressFromDMR = getUserAddressFromDMR;
const getUserIsCompanyFromDMR = (dmr) => {
    return dmr.User_Type !== 'Privat';
};
exports.getUserIsCompanyFromDMR = getUserIsCompanyFromDMR;
const getOwnerFromDMR = (dmr) => {
    return {
        address: (0, exports.getOwnerAddressFromDMR)(dmr),
        isCompany: (0, exports.getOwnerIsCompanyFromDMR)(dmr),
        birthdate: (0, moment_1.default)(dmr.Owner_Birth_Date, 'YYYY-MM-DD').toISOString(),
        description: 'Ejer',
        name: dmr.Owner_Name,
        cvr: dmr.Owner_VAT_Registration_No || null,
    };
};
exports.getOwnerFromDMR = getOwnerFromDMR;
const getOwnerAddressFromDMR = (dmr) => {
    return {
        address: dmr.Owner_Address,
        coAddress: dmr.Owner_Address_2,
        zipcode: dmr.Owner_Post_Code,
        city: dmr.Owner_City,
        country: dmr.Owner_Country_Code || 'Danmark',
    };
};
exports.getOwnerAddressFromDMR = getOwnerAddressFromDMR;
const getOwnerIsCompanyFromDMR = (dmr) => {
    return dmr.Owner_Type !== 'Privat';
};
exports.getOwnerIsCompanyFromDMR = getOwnerIsCompanyFromDMR;
exports.discountedCarRentalCompaniesCVR = [
    '26045215',
    '27972721',
    '19986292',
    '30709594',
];
//# sourceMappingURL=index.js.map